<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">変更確認</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <wj-tab-panel #tab_Top [style.width.px]="1000" [style.height.px]="748" (selectedIndexChanged)="setFocus()"
          [tabindex]="-1" class="space-bottom">
          <div class="tabBox">
            <ng-template ngFor let-item [ngForOf]="this.kymw0901Model.dataKeys" let-i="index">
              <wj-tab *ngIf="this.tabsInfo[item]">
                <a>{{ this.tabsInfo[item] }}</a>
                <wj-flex-grid #dtg_UpdatedList (initialized)="onInitialized(dtg_UpdatedList)" [style.width.px]="992"
                  [style.height.px]="712" [style.padding.px]="0" id="dtg_UpdatedList" [tabindex]="0"
                  [itemsSource]="this.kymw0901Model.tabData[item]" [headersVisibility]="'Column'"
                  [selectionMode]="'Row'" (updatingView)="itemsSorceChanged(dtg_UpdatedList);"
                  (itemsSourceChanged)="setFocus()" (keydown)="eventMoveToFocusHandler($event)" [isReadOnly]="true" class="always-scrollbars">
                  <wj-flex-grid-column [minWidth]="5" [width]="275" [binding]="'changeItemName'" [header]="'変更項目'">
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [width]="60" [binding]="'skewerSelect'" [header]="'串刺'">
                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                      <input type="checkbox" class="selected" [(ngModel)]="cell.item.skewerSelect"
                        [disabled]="cell.item.skewerSelectLock === '1' ? true : false"
                        id="cb_updated_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                        (change)="changeCheckHandler(item, cell.item)" />
                    </ng-template>
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [width]="302" [binding]="'contentBeforeChange'" [header]="'変更前'"
                    [wordWrap]="true">
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [width]="34" [binding]="''" [header]="'⇒'" [align]="'center'">
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [width]="302" [binding]="'contentAfterChange'" [header]="'変更後'"
                    [wordWrap]="true">
                  </wj-flex-grid-column>
                </wj-flex-grid>
              </wj-tab>
            </ng-template>
          </div>
        </wj-tab-panel>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button #btn_SaveChangeFixation id="btn_SaveChangeFixation" forcedEnabledMode="none" [tabindex]="0"
            (keydown)="eventMoveFromChangeFixationsHandler($event)" class="btn-primary"
            (click)="eventSaveChangeFixation_ClickHandler(null)">変更確定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler($event)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>